import { Button, usePromptModal } from '@hive/component';
import type { Collection } from '@hive/env/filter';
import { useI18n } from '@hive/i18n';
import { SaveIcon } from '@blocksuite/icons/rc';
import { nanoid } from 'nanoid';
import { useCallback } from 'react';

import { createEmptyCollection } from '../use-collection-manager';
import * as styles from './save-as-collection-button.css';

interface SaveAsCollectionButtonProps {
  onConfirm: (collection: Collection) => void;
}

export const SaveAsCollectionButton = ({
  onConfirm,
}: SaveAsCollectionButtonProps) => {
  const t = useI18n();
  const { openPromptModal } = usePromptModal();
  const handleClick = useCallback(() => {
    openPromptModal({
      title: t['com.hive.editCollection.saveCollection'](),
      label: t['com.hive.editCollectionName.name'](),
      inputOptions: {
        placeholder: t['com.hive.editCollectionName.name.placeholder'](),
      },
      children: (
        <div className={styles.createTips}>
          {t['com.hive.editCollectionName.createTips']()}
        </div>
      ),
      confirmText: t['com.hive.editCollection.save'](),
      cancelText: t['com.hive.editCollection.button.cancel'](),
      confirmButtonOptions: {
        variant: 'primary',
      },
      onConfirm(name) {
        onConfirm(createEmptyCollection(nanoid(), { name }));
      },
    });
  }, [openPromptModal, t, onConfirm]);
  return (
    <Button
      onClick={handleClick}
      data-testid="save-as-collection"
      prefix={<SaveIcon />}
      className={styles.button}
    >
      {t['com.hive.editCollection.saveCollection']()}
    </Button>
  );
};
